import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {ErrorRoutingModule} from './error-routing.module';
import {AccessDeniedComponent} from './pages/access-denied/access-denied.component';
import {NotFoundComponent} from './pages/not-found/not-found.component';

@NgModule({
  imports: [CommonModule, ErrorRoutingModule, SharedModule],
  declarations: [AccessDeniedComponent, NotFoundComponent]
})
export class ErrorModule {}
